import { baseEnvironmentProd } from "src/environments/baseEnvironment.prod";

export const environment = {
  ...baseEnvironmentProd,
  organizationPrefix: 'RAC',
  organizationUUID: '70a1b873-9291-4cf2-ab44-c34a965ca2cd',
  activeLanguage: 'en-US',
  multipleAdminCommunity: false,
  requiredField: {},
  systemToken: '',
  htmlFields: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ header: 1 }, { header: 2 }],
    ['blockquote'],
    [{ color: [] }, { background: [] }],
    [{ script: 'sub' }, { script: 'super' }, 'link'],
    [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
    ['clean'],
  ],
  basicConfiguration: undefined,
  googleAPIKey: '',
  manageTemplates: false,
  manageUserFilter: false,

  productEditorTabIcons: ['r', 'z', 'M', 'x', 'm'],
  pwaThemeColor: 'rgba(0, 72, 205, 1.0)',
};
